import api from './api';

// Tipos de datos para UF Locations
export interface UFLocation {
  id: number;
  name: string;
  color: string;
  usages: number;
}

interface UFLocationResponse {
  success: boolean;
  message: string;
  data: UFLocation | UFLocation[];
}

interface CreateUFLocationDTO {
  name: string;
  color: string;
}

interface UpdateUFLocationDTO {
  name: string;
  color: string;
}

// Servicios para UF Locations

/**
 * Obtiene todas las ubicaciones de unidades funcionales
 */
export const getAllUFLocations = async (): Promise<UFLocation[]> => {
  const response = await api.get<UFLocationResponse>('/uf-locations');
  return Array.isArray(response.data.data) ? response.data.data : [];
};

/**
 * Crea una nueva ubicación de unidad funcional
 */
export const createUFLocation = async (
  data: CreateUFLocationDTO,
): Promise<UFLocation> => {
  const response = await api.post<UFLocationResponse>('/uf-locations', data);
  return response.data.data as UFLocation;
};

/**
 * Actualiza una ubicación de unidad funcional existente
 */
export const updateUFLocation = async (
  id: number,
  data: UpdateUFLocationDTO,
): Promise<void> => {
  await api.put(`/uf-locations/${id}`, data);
};

/**
 * Elimina una ubicación de unidad funcional
 */
export const deleteUFLocation = async (id: number): Promise<void> => {
  await api.delete(`/uf-locations/${id}`);
};
